<template>
  <section v-loading="publishing" class="page-container">
    <div class="page-section">
      <el-form ref="form" :model="postForm" label-width="80px">
        <el-form-item label="商品ID">
          <el-input v-model="postForm.goodsId" placeholder="商品ID" />
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="postForm.userId" placeholder="用户ID" />
        </el-form-item>
        <el-form-item label="内容">
          <simple-editor ref="simpleEditor" @input="onSimpleEditorInput" @submit="submitCreate" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="publishing" @click="submitCreate">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import SimpleEditor from "@/components/SimpleEditor";
export default {
  name: "PublishGoodsShow",
  components: { SimpleEditor },
  data() {
    return {
      publishing: false,
      postForm: {
        goodsId: "",
        userId: "",
        content: "",
        imageList: [],
      },
    };
  },
  mounted() {},
  methods: {
    onSimpleEditorInput(value) {
      this.postForm.content = value.content;
      this.postForm.imageList = value.imageList;
    },
    async submitCreate() {
      if (this.publishing) {
        return;
      }
      this.publishing = true;

      try {
        if (this.$refs.simpleEditor && this.$refs.simpleEditor.isOnUpload()) {
          this.$message.warning("图片上传中，请稍后提交");
          return;
        }
        await this.axios.form("base:/api/admin/topic/create_goods_show", {
          goodsId: this.postForm.goodsId,
          userId: this.postForm.userId,
          title: this.postForm.title,
          content: this.postForm.content,
          imageList:
            this.postForm.imageList && this.postForm.imageList.length
              ? JSON.stringify(this.postForm.imageList)
              : "",
        });
        this.$message.success("提交成功");
        this.$refs.simpleEditor.clear();
        this.postForm.goodsId = "";
        this.postForm.userId = "";
        this.postForm.content = "";
        this.postForm.imageList = [];
      } catch (e) {
        this.$message.error(e.message || e);
      } finally {
        this.publishing = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
